import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import UserService from "./services/UserService";
import HttpService from "./services/HttpService";

const container = document.getElementById('root');
const root = createRoot(container);

const renderApp = () => {
    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
};

UserService.initKeycloak(renderApp);
HttpService.configure();